import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarSendFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.8763 1.9209H11.1233V8.11624L8.15743 5.11636L7.03369 6.2401L11.9998 11.2062L16.966 6.2401L15.8422 5.11636L12.8763 8.11624V1.9209ZM5.14805 11.4099L6.58111 8.44141L12.0166 13.8769L17.433 8.46054L18.8569 11.4099H21.1009V13.0419H19.6321L20.1217 14.0415V19.9983C20.1217 21.1203 19.2241 22.0383 18.1021 22.0383C17.2249 22.0383 16.3273 21.5079 16.1029 20.4063H7.90205C7.67765 21.5079 6.78005 22.0383 5.90285 22.0383C4.78085 22.0383 3.88325 21.1203 3.88325 19.9983V14.0415L4.37285 13.0419H2.90405V11.4099H5.14805ZM12.0025 16.3467C11.2273 16.3467 10.5541 15.9591 10.1257 15.3675H6.98405V16.8975H9.53405C10.2073 17.4687 11.0641 17.8359 12.0025 17.8359C12.9409 17.8359 13.7977 17.4687 14.4709 16.8975H17.0209V15.3675H13.8793C13.4509 15.9591 12.7777 16.3467 12.0025 16.3467Z"
      />
    </SvgIcon>
  );
});
